var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"photo",attrs:{"href":_vm.url}},[_c('div',{staticClass:"photo__inner",style:({ backgroundImage: ("url(" + _vm.src + ")") })}),_vm._v(" "),_c('plus-icon',{staticClass:"photo__plus"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4857c8eb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Photo.vue
// module id = null
// module chunks = 